import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class TableRow extends PureComponent {
    render() {
        const { children } = this.props;
        const props = {
            ...this.props,
            className: `dl-table-row ${ style.tableRow } ${ this.props.className }`.trim(),
            children: undefined,
        };

        return (
            <div { ...props }>
                { children }
            </div>
        );
    }
}
TableRow.defaultProps = {
    className: '',
};
